export interface IDosageValueModel {
	dosageId: number;
	dosageItemId: number;
	description: string;
	uom: string;
	value: number;
	addToInvoice: boolean;
	costOverride?: number;
}

export class DosageValueModel implements IDosageValueModel {
	dosageId: number = 0;
	dosageItemId: number = 0;
	description: string = "";
	uom: string = "";
	value: number = null;
	addToInvoice: boolean = false;
	costOverride?: number = null;
}
